// extracted by mini-css-extract-plugin
export default {"container":"BasicPlanBanner_container__7KN4f"};